export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:9292";

export const APP_URL = process.env.REACT_APP_WEB_URL || "http://localhost:3000";

export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

export const FREE_PLAN_NAME = "free_plan";
